<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 2 8"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect :fill="fill" height="5" rx="1" width="2" y="3"/>
    <circle cx="1" cy="1" :fill="fill" r="1"/>
  </svg>
</template>

<script>
export default {
  name: 'Info',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};
</script>
